








































































































































































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import {
  CustomerArchiveToggleCommand,
  CustomerFilter,
  CustomerViewModel,
  ProjectArchiveToggleCommand,
  ProjectBudgetViewModel,
  ProjectFilter,
  ProjectFinishToggleCommand,
  ProjectViewModel
} from "@/services/api/nswag/stapiclient_generated";
import { stCustomerApi, stProjectApi } from "@/services/st-api";
import StToggle from "@/components/basic/StToggle.vue";
import StInput2 from "@/components/basic/StInput2.vue";
import StSearch from "@/components/basic/StSearch.vue";
import StProgress from "@/components/basic/StProgress.vue";
import { notifySuccess } from "@/utlitities/notifications";
import StBadge from "@/components/basic/StBadge.vue";
import { DialogResponse } from "vue-tailwind/dist/components/TDialog";
import { UserStore } from "@/store/user-module";
import ProjectSingle from "@/views/Projects/ProjectSingle.vue";
import ProjectBudget from "@/views/Projects/ProjectBudget.vue";
import { formatDate } from "@/utlitities/helper";
import {DebouncedText} from '@/utlitities/debounced-text';

Component.registerHooks(["beforeRouteUpdate"]);

@Component({
  methods: { formatDate },
  components: {
    StBadge,
    StProgress,
    StSearch,
    StInput2,
    StToggle,
    ProjectSingle,
    ProjectBudget
  }
})
export default class Projects extends Vue {
  customers: CustomerViewModel[] = [];
  projectBudgets: ProjectBudgetViewModel[] = [];
  search: DebouncedText = new DebouncedText();
  private budgetLoading: boolean = true;
  private showArchived: boolean = false;
  searchMode: "customer" | "project" = "project";
  searchModeOptions = [
    { text: "Projekte", value: "project", icon: "far fa-file-alt" },
    { text: "Kunden", value: "customer", icon: "far fa-address-card" }
  ];
  showProjectTasks: boolean = false;

  delCustomerLoading: boolean = false;
  delProjectLoading: boolean = false;
  archiveCustomerLoadingId = 0;
  archiveProjectLoadingId = 0;
  finishProjectLoadingId = 0;

  loading = true;
  delayLoading = false;

  get currency() {
    return UserStore.userSettings.currency;
  }

  async mounted() {
    try {
      this.loading = true;
      await this.loadData();
    } finally {
      this.loading = false;
    }

    await this.loadBudget();
  }

  get searchTextHasBeenSetRecently() {
    return this.search.hasBeenSetRecently;
  }

  async beforeRouteUpdate(to: any, from: any, next: any) {
    next();
    if (to.name == "Projects") {
      try {
        let projectId = (from as any).params?.projectid;
        if ((from as any).name == "EditCustomer") {
          let customerId = (from as any).params?.id;
          const customer = this.customers.find(x => x.id == customerId);
          if (customer?.hasNoProjects) {
            projectId = this.getDummyCustomerProject(customer).id;
          }
        }
        this.delayLoading = true;

        await this.loadData();

        if (projectId) {
          const projectFilter: ProjectFilter = ProjectFilter.fromJS({ id: projectId });
          let budgetIndex = this.projectBudgets.findIndex((x) => x.projectId == projectId);

          const apiBudgetModels = await stProjectApi.getProjectBudgets(projectFilter);
          const hasApiBudget = apiBudgetModels.length && (apiBudgetModels[0]?.budget ?? 0) > 0;

          if (hasApiBudget) {
            if (budgetIndex > -1) {
              this.projectBudgets[budgetIndex] = apiBudgetModels[0];
            } else {
              this.projectBudgets.push(apiBudgetModels[0]);
            }
          } else {
            if (budgetIndex > -1) {
              this.projectBudgets.splice(budgetIndex, 1);
            }
          }
        }
      } finally {
        this.delayLoading = false;
      }
    }
  }

  getCustomerProject(customer: CustomerViewModel) {
    if (!customer.hasNoProjects || !customer.projects.length) {
      return ProjectViewModel.fromJS({ projects: [] });
    }

    return customer.projects[0];
  }

  get canEditCustomersAndProjects() {
    return UserStore.userSettings.CanEditCustomersAndProjects;
  }

  async toggleShowArchived() {
    try {
      this.loading = true;
      this.showArchived = !this.showArchived;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  getDummyCustomerProject(customer: CustomerViewModel) {
    return customer.projects![0]!;
  }

  getBudgetModel(project: ProjectViewModel) {
    if (!project?.id) {
      return;
    }

    const budget = this.projectBudgets.find(x => x.projectId == project.id);

    if (!budget) {
      return;
    }

    return budget;
  }

  hasBudget(project: ProjectViewModel) {
    return project?.hasBudget ?? false;
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get canViewProjectReport() {
    return UserStore.userSettings.CanViewTimeEntriesForEmployees;
  }

  canViewBudget(project: ProjectViewModel) {
    const budgetModel = this.getBudgetModel(project);

    return !!budgetModel;
  }

  async loadData() {
    const filter: CustomerFilter = CustomerFilter.fromJS({
      isArchived: this.showArchived,
      showArchivedProjects: this.showArchived
    });
    this.customers = await stCustomerApi.getList(filter);
  }

  async loadBudget() {
    this.budgetLoading = true;
    const projectFilter: ProjectFilter = ProjectFilter.fromJS({ isArchived: this.showArchived });
    this.projectBudgets = await stProjectApi.getProjectBudgets(projectFilter);
    this.budgetLoading = false;
  }

  get filteredCustomers(): CustomerViewModel[] {
    if (!this.search.val) {
      return this.customers.filter(_ => !_.isBasicTimeTrackingDefaultCustomer);
    }

    if (this.searchMode == "project") {
      return this.customers.filter(_ => !_.isBasicTimeTrackingDefaultCustomer)
        .map((c) => {
          c = CustomerViewModel.fromJS({ ...c });
          c.projects = c.projects?.filter((p) => p.name?.toLowerCase().indexOf(this.search.val.toLowerCase()) != -1);
          return c;
        }, this)
        .filter((c) => c.projects?.length);
    } else {
      return this.customers.filter((_) => _.name?.toLowerCase().indexOf(this.search.val.toLowerCase()) != -1);
    }
  }

  customerIsReadonly(customer: CustomerViewModel) {
    return customer.hasNoProjects && this.getCustomerProject(customer).isReadonly;
  }

  createNewCustomer() {
    this.$router.push({ name: "EditCustomer", params: { id: "0" } });
  }

  editCustomer(customer: CustomerViewModel) {
    let params : any = { id: customer.id.toString() }
    let name = 'EditCustomer'

    if(this.customerIsReadonly(customer)){
      params.readonly = true;
      name = 'ViewCustomer';
    }

    if (this.canEditCustomersAndProjects) {
      this.$router.push({ name: name, params: params });
    }
  }

  editProject(item: ProjectViewModel) {
    if (this.canEditCustomersAndProjects) {
      this.$router.push({
        name: "EditProject",
        params: { customerid: item.customerId!.toString(), projectid: item.id!.toString() }
      });
    }
  }

  projectReport(item: ProjectViewModel) {
    this.$router.push({
      name: "ProjectReport",
      params: { customerid: item.customerId!.toString(), projectid: item.id!.toString() }
    });
  }

  newProject(customerid: number) {
    this.$router.push({ name: "EditProject", params: { customerid: customerid.toString(), projectid: "0" } });
  }

  async toggleProjectFinish(id: number) {
    try {
      this.finishProjectLoadingId = id;
      await stProjectApi.toggleFinishProject(ProjectFinishToggleCommand.fromJS({ projectId: id }));
      await this.loadData();
      notifySuccess("Erfolgreich gespeichert");

    } finally {
      this.finishProjectLoadingId = 0;
    }
  }

  async toggleProjectArchive(id: number) {
    try {
      this.archiveProjectLoadingId = id;
      await stProjectApi.toggleArchiveProject(ProjectArchiveToggleCommand.fromJS({ projectId: id }));
      await this.loadData();
      notifySuccess("Erfolgreich gespeichert");

    } finally {
      this.archiveProjectLoadingId = 0;
    }
  }

  async toggleCustomerArchive(id: number) {
    try {
      this.archiveCustomerLoadingId = id;
      await stCustomerApi.toggleArchiveCustomer(CustomerArchiveToggleCommand.fromJS({ customerId: id }));
      await this.loadData();
      notifySuccess("Erfolgreich gespeichert");
    } finally {
      this.archiveCustomerLoadingId = 0;
    }
  }

  async projectDelete(id: number) {
    try {
      this.delProjectLoading = true;
      const result = await stProjectApi.delete(id, false);
      if (result.confirmationNeeded) {
        const res: DialogResponse = await this.$dialog.confirm({
          title: this.$t("Bestätigung").toString(),
          text: result.message,
          variant: "danger",
          okButtonText: this.$t("Löschen").toString(),
          cancelButtonText: this.$t("Abbrechen").toString()
        });
        if (res.isOk) {
          await stProjectApi.delete(id, true);
          await this.loadData();
          notifySuccess("Erfolgreich gelöscht");
        }
      } else {
        await this.loadData();
        notifySuccess("Erfolgreich gelöscht");
      }
    } finally {
      this.delProjectLoading = false;
    }
  }

  async customerDelete(id: number) {
    try {
      this.delCustomerLoading = true;
      const result = await stCustomerApi.delete(id, false);
      if (result.confirmationNeeded) {
        const res: DialogResponse = await this.$dialog.confirm({
          title: this.$t("Bestätigung").toString(),
          text: result.message,
          variant: "danger",
          okButtonText: this.$t("Löschen").toString(),
          cancelButtonText: this.$t("Abbrechen").toString()
        });
        if (res.isOk) {
          await stCustomerApi.delete(id, true);
          await this.loadData();
          notifySuccess("Erfolgreich gelöscht");
        }
      } else {
        await this.loadData();
        notifySuccess("Erfolgreich gelöscht");
      }
    } finally {
      this.delCustomerLoading = false;
    }
  }
}
